import { Injectable } from '@angular/core';
import RestService from 'src/app/utils/restservice';

@Injectable({
  providedIn: 'root'
})
export class WarehouseService {
  constructor(private restService: RestService) {}

  listPrincipal(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('config/warehouses/principal', val_params);
  }

  listWarehouseBranchoffice(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('config/warehouses/branchoffice', val_params);
  }

  listConceptEntry(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('warehouse/concepts/entry', val_params);
  }

  listConceptOutput(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('warehouse/concepts/output', val_params);
  }

  listEntry(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('entry/list', val_params);
  }

  getEntry(val_id: number) {
    return this.restService.get('entry/edit', val_id);
  }

  saveEntry(data: any) {
    return this.restService.save('entry/save', data);
  }

  updateEntry(val_id: number, data: any) {
    return this.restService.update('entry/update', val_id, data);
  }
  
  deleteEntry(val_id: number) {
    return this.restService.delete('entry/delete', val_id);
  }

  listOutput(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('output/list', val_params);
  }

  saveOutput(data: any) {
    return this.restService.save('output/save', data);
  }

  detail(val_id: number) {
    return this.restService.get('entry/detail', val_id);
  }

  listStockGeneral(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('stockgeneral/list', val_params);
  }

}
